import React, { useState } from "react";
import { ReactElement } from "react";

import "./contact.scss";
import { useTranslation } from "react-i18next";


export default function Contact(): ReactElement {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  async function submitForm(e) {
    e.preventDefault();
    setLoading(true)

    const formData = new FormData(e.target);
    // accessKey designed to be public
    formData.append("accessKey", "dbacb2a6934d77346423114baedc5e0649885476cdb3afcf2382c0ac019306b0");
    let data = Object.fromEntries(formData.entries())
    try {
      fetch("/api/submit-form", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }).then(async (result) => {
        const responseData = await result.json();
        if (responseData.status === 'success') {
          setStatus("success");
          e.target.reset();
        } else {
          setStatus("error");
        }
        setLoading(false);
      });
    } catch (e) {
      console.error('Network error submitting form:', e)
      setLoading(false)
    }
  }

  return (
    <div className="flex-grow-1 bg-light-gradient">
      <div hidden={status !== 'success'} className="app-body bg-success w-100 m-0 py-4 text-center text-light">
        <p className="m-0">{t("contact.successText")}</p>
      </div>
      <div hidden={status !== 'error'} className="app-body bg-danger w-100 m-0 py-4 text-center text-light">
        <p className="m-0">{t("contact.errorText")}</p>
      </div>
      <div className="app-body">
        <div className="container">
          <div className="row justify-content-center">
            <form className="col-12 col-lg-6 needs-validation my-5" onSubmit={submitForm}>
              <h1>{t("contact.heading")}</h1>
              <div className="row row-gap-3">
                <div className="col-12 col-xxl-6">
                  <label htmlFor="name" className="form-label">{t("contact.name")}</label>
                  <input type="text" className="form-control" id="name" name="name" disabled={loading} required/>
                </div>
                <div className="col-12 col-xxl-6">
                  <label htmlFor="email" className="form-label">{t("contact.email")}</label>
                  <input type="email" className="form-control" id="email" name="email" disabled={loading} required/>
                </div>
                <div className="col-12">
                  <label htmlFor="message" className="form-label">{t("contact.message")}</label>
                  <textarea className="form-control" id="message" name="message" disabled={loading} required/>
                </div>
                <input className="d-none" type="hidden" name="accessKey" value=""/>
                <input className="d-none" type="text" name="honeypot"/>
                <div className="col-12 d-flex justify-content-end">
                  <button type="submit"
                          className="btn btn-primary px-4 d-flex align-items-center justify-content-center"
                          disabled={loading}>
                    <div hidden={!loading} className="loader loader-button me-2"></div>
                    {t("contact.submit")}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}